import React from "react";
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
} from "@chakra-ui/react";
import { getNextStepsFromModuleSteps } from "@utils";
import { IFormField } from "./fieldTypes";
import { collection, getDocs, query, where } from "firebase/firestore";
import { Module, DB_COLLECTION_NAMES } from "@constants";
import { FirebaseContext } from "@contexts";
import { Controller } from "react-hook-form";
import { useParams } from "react-router-dom";

import {
  AutoComplete,
  AutoCompleteCreatable,
  AutoCompleteInput,
  AutoCompleteItem,
  AutoCompleteList,
} from "@choc-ui/chakra-autocomplete";

/**
 * JsonForm Autocomplete Field component.
 * @param props see {@link IFormField}
 */
function AutocompleteField({
  field,
  isRequired,
  register,
  errorMessage = "",
}: IFormField) {
  const test: string[] = [];

  const { firestore } = React.useContext(FirebaseContext);
  const { productionStep } = useParams();

  const collectionRef = collection(firestore, DB_COLLECTION_NAMES.MODULES);
  let moduleType = "";
  if (field.fieldName.indexOf("Baseplate")) {
    moduleType = "part:baseplate";
  }

  const queryResult = query(
    collectionRef,
    where("queryTokens", "array-contains", moduleType),
  );

  Promise.all([getDocs(queryResult)]).then(([testResult]) => {
    testResult.forEach((doc) => {
      const module = doc.data() as Module;
      const nextStep = getNextStepsFromModuleSteps("PS", module.steps);
      if (nextStep[0] == productionStep) {
        test.push(doc.data().id);
      }
    });
  });

  return (
    <FormControl isRequired={isRequired} isInvalid={!!errorMessage}>
      <FormLabel>{field.label}</FormLabel>
      <Controller
        {...register(field.fieldName, field.config)}
        render={({ field }) => (
          <AutoComplete
            openOnFocus
            onChange={(value) => value && field.onChange(value)}
          >
            <AutoCompleteInput
              placeholder="Select option..."
              onChange={field.onChange}
              value={field.value}
            ></AutoCompleteInput>
            <AutoCompleteList>
              {test.map((option) => (
                <AutoCompleteItem key={option} value={option} />
              ))}
              <AutoCompleteCreatable />
            </AutoCompleteList>
          </AutoComplete>
        )}
      />
      <FormErrorMessage>{errorMessage}</FormErrorMessage>
      {!errorMessage && field.helperText && (
        <FormHelperText>{field.helperText}</FormHelperText>
      )}
    </FormControl>
  );
}

export { AutocompleteField };
